"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Add_1 = require("@mui/icons-material/Add");
const Check_1 = require("@mui/icons-material/Check");
const merge_1 = require("merge");
const addItem_styles_1 = require("./addItem.styles");
function index({ state, onClick, disabled = false, checkIconOverrides, addIconOverrides }) {
    const styles = (0, addItem_styles_1.default)();
    const handleClick = (e) => {
        if (disabled || !onClick)
            return;
        onClick(e);
    };
    if (state) {
        return (0, jsx_runtime_1.jsx)(Check_1.default, { sx: (0, merge_1.merge)(true, styles.paidCheckIcon, checkIconOverrides), onClick: handleClick });
    }
    return (0, jsx_runtime_1.jsx)(Add_1.default, { sx: (0, merge_1.merge)(true, styles.paidPlusIcon, addIconOverrides), onClick: handleClick });
}
exports.default = index;
